// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskTableHeader-module__font-s-10___6dH0S {
  font-size: 10px !important;
}

.TaskTableHeader-module__font-s-12___opbQ2 {
  font-size: 12px !important;
}

.TaskTableHeader-module__font-s-13___BZ7pb {
  font-size: 13px !important;
}

.TaskTableHeader-module__font-s-14___sCAxo {
  font-size: 14px !important;
}

.TaskTableHeader-module__font-s-15___ALSKo {
  font-size: 15px !important;
}

.TaskTableHeader-module__font-s-16___CZ0Fj {
  font-size: 16px !important;
}

.TaskTableHeader-module__font-s-18___MWgdI {
  font-size: 18px !important;
}

.TaskTableHeader-module__font-s-20___C8ANH {
  font-size: 20px !important;
}

.TaskTableHeader-module__font-s-22___OwZdt {
  font-size: 22px !important;
}

.TaskTableHeader-module__font-s-28___GP6jL {
  font-size: 28px !important;
}

.TaskTableHeader-module__font-w-400___HDrCZ {
  font-weight: 400 !important;
}

.TaskTableHeader-module__font-w-500___UpIBQ {
  font-weight: 500 !important;
}

.TaskTableHeader-module__font-w-600___QyH92 {
  font-weight: 600 !important;
}

.TaskTableHeader-module__font-w-700___ThtRC {
  font-weight: 700 !important;
}

.TaskTableHeader-module__p-5___tKmzs {
  padding: 5px !important;
}

.TaskTableHeader-module__p-12___BeAwf {
  padding: 12px !important;
}

.TaskTableHeader-module__p-16___Bia6M {
  padding: 16px !important;
}

.TaskTableHeader-module__p-30___pGkKR {
  padding: 30px !important;
}

.TaskTableHeader-module__p-b-0___onF57 {
  padding-bottom: 0 !important;
}

.TaskTableHeader-module__p-b-5___f0MaN {
  padding-bottom: 5px !important;
}

.TaskTableHeader-module__p-b-10___AQJNR {
  padding-bottom: 10px !important;
}

.TaskTableHeader-module__p-b-12___fM8aC {
  padding-bottom: 12px !important;
}

.TaskTableHeader-module__p-b-16___WB__Y {
  padding-bottom: 16px !important;
}

.TaskTableHeader-module__p-b-18___llZxp {
  padding-bottom: 18px !important;
}

.TaskTableHeader-module__p-b-20___bBYpV {
  padding-bottom: 20px !important;
}

.TaskTableHeader-module__p-b-25___GWblJ {
  padding-bottom: 25px !important;
}

.TaskTableHeader-module__p-b-30___wb97X {
  padding-bottom: 30px !important;
}

.TaskTableHeader-module__p-b-50___yMo5d {
  padding-bottom: 50px !important;
}

.TaskTableHeader-module__p-t-0___TY_PA {
  padding-top: 0 !important;
}

.TaskTableHeader-module__p-t-12___lfCNI {
  padding-top: 12px !important;
}

.TaskTableHeader-module__p-t-16___DzDPs {
  padding-top: 16px !important;
}

.TaskTableHeader-module__p-t-18___keO7Z {
  padding-top: 18px !important;
}

.TaskTableHeader-module__p-t-20___Ggn8a {
  padding-top: 20px !important;
}

.TaskTableHeader-module__p-t-30___sdk8r {
  padding-top: 30px !important;
}

.TaskTableHeader-module__p-t-40___SKu_b {
  padding-top: 40px !important;
}

.TaskTableHeader-module__p-t-50___cgpEV {
  padding-top: 50px !important;
}

.TaskTableHeader-module__p-l-20___vtKpW {
  padding-left: 20px !important;
}

.TaskTableHeader-module__p-l-30___LigoG {
  padding-left: 30px !important;
}

.TaskTableHeader-module__p-l-40___pACBU {
  padding-left: 40px !important;
}

.TaskTableHeader-module__p-r-16___BgnNR {
  padding-right: 16px !important;
}

.TaskTableHeader-module__p-r-20___eippp {
  padding-right: 20px !important;
}

.TaskTableHeader-module__p-r-30___qDAbj {
  padding-right: 30px !important;
}

.TaskTableHeader-module__p-r-50____yGUz {
  padding-right: 50px !important;
}

.TaskTableHeader-module__p-r-60___kiRNE {
  padding-right: 60px !important;
}

.TaskTableHeader-module__m-b-1___YqGvI {
  margin-bottom: 1px !important;
}

.TaskTableHeader-module__m-b-2___fcGhI {
  margin-bottom: 2px !important;
}

.TaskTableHeader-module__m-b-6___fqy5O {
  margin-bottom: 6px !important;
}

.TaskTableHeader-module__m-b-8___pQjJa {
  margin-bottom: 8px !important;
}

.TaskTableHeader-module__m-b-10___bD1lg {
  margin-bottom: 10px !important;
}

.TaskTableHeader-module__m-b-14___yYWCQ {
  margin-bottom: 14px !important;
}

.TaskTableHeader-module__m-b-16___YoySF {
  margin-bottom: 16px !important;
}

.TaskTableHeader-module__m-b-20___cJUhN {
  margin-bottom: 20px !important;
}

.TaskTableHeader-module__m-b-22___nUAYu {
  margin-bottom: 22px !important;
}

.TaskTableHeader-module__m-b-24___y3xlC {
  margin-bottom: 24px !important;
}

.TaskTableHeader-module__m-b-30___MKXEm {
  margin-bottom: 30px !important;
}

.TaskTableHeader-module__m-b-32___kdEj2 {
  margin-bottom: 32px !important;
}

.TaskTableHeader-module__m-b-40___DdCBo {
  margin-bottom: 40px !important;
}

.TaskTableHeader-module__m-t-2___gME_Y {
  margin-top: 2px !important;
}

.TaskTableHeader-module__m-t-3___r451N {
  margin-top: 3px !important;
}

.TaskTableHeader-module__m-t-4___l3nv0 {
  margin-top: 4px !important;
}

.TaskTableHeader-module__m-t-5___wMYXl {
  margin-top: 5px !important;
}

.TaskTableHeader-module__m-t-8___dyFiu {
  margin-top: 8px !important;
}

.TaskTableHeader-module__m-t-10___aak2C {
  margin-top: 10px !important;
}

.TaskTableHeader-module__m-t-15___WqE8b {
  margin-top: 15px !important;
}

.TaskTableHeader-module__m-t-16___Zm2kM {
  margin-top: 16px !important;
}

.TaskTableHeader-module__m-t-20___Z6Ouq {
  margin-top: 20px !important;
}

.TaskTableHeader-module__m-t-22___Gt1N8 {
  margin-top: 22px !important;
}

.TaskTableHeader-module__m-t-30___mcF7W {
  margin-top: 30px !important;
}

.TaskTableHeader-module__m-t-32___XPXD1 {
  margin-top: 32px !important;
}

.TaskTableHeader-module__m-l-auto___cUFH4 {
  margin-left: auto !important;
}

.TaskTableHeader-module__m-l-4___bBH30 {
  margin-left: 4px !important;
}

.TaskTableHeader-module__m-l-5___coq0o {
  margin-left: 5px !important;
}

.TaskTableHeader-module__m-l-6___AvU20 {
  margin-left: 6px !important;
}

.TaskTableHeader-module__m-l-8___GcXcO {
  margin-left: 8px !important;
}

.TaskTableHeader-module__m-l-10___KtyUD {
  margin-left: 10px !important;
}

.TaskTableHeader-module__m-l-16___m4TrT {
  margin-left: 16px !important;
}

.TaskTableHeader-module__m-l-20___Xfto_ {
  margin-left: 20px !important;
}

.TaskTableHeader-module__m-l-24___mJi_P {
  margin-left: 24px !important;
}

.TaskTableHeader-module__m-l-30___g9Lo3 {
  margin-left: 30px !important;
}

.TaskTableHeader-module__m-l-35___VPfAs {
  margin-left: 35px !important;
}

.TaskTableHeader-module__m-l-40___vqWSg {
  margin-left: 40px !important;
}

.TaskTableHeader-module__m-r-8___hJz0u {
  margin-right: 8px !important;
}

.TaskTableHeader-module__m-r-10___Jj_lw {
  margin-right: 10px !important;
}

.TaskTableHeader-module__m-r-16___IXSlK {
  margin-right: 16px !important;
}

.TaskTableHeader-module__m-r-20___JvbiS {
  margin-right: 20px !important;
}

.TaskTableHeader-module__m-r-24___cjZdI {
  margin-right: 24px !important;
}

.TaskTableHeader-module__m-r-30___hkvQy {
  margin-right: 30px !important;
}

.TaskTableHeader-module__m-r-40___FvzI1 {
  margin-right: 40px !important;
}

.TaskTableHeader-module__border-r-3___C9BOt {
  border-radius: 3px !important;
}

.TaskTableHeader-module__border-r-4___ERuuw {
  border-radius: 4px !important;
}

.TaskTableHeader-module__border-r-6___gX5Hb {
  border-radius: 6px !important;
}

.TaskTableHeader-module__border-r-10___cbmG7 {
  border-radius: 10px !important;
}

.TaskTableHeader-module__border-r-12___ZBy_p {
  border-radius: 12px !important;
}

.TaskTableHeader-module__border-r-16___tlnK6 {
  border-radius: 16px !important;
}

.TaskTableHeader-module__border-r-50___THjCw {
  border-radius: 50% !important;
}

.TaskTableHeader-module__primary-border___a1htA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskTableHeader-module__primary-border-b___NG3dP {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskTableHeader-module__primary-border-t___UrF9z {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskTableHeader-module__primary-border-l___RKWip {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskTableHeader-module__primary-border-r___onSW9 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskTableHeader-module__secondary-border___eQrH6 {
  border: 1px solid #637768;
}

.TaskTableHeader-module__secondary-border-b___US8dT {
  border-bottom: 1px solid #637768;
}

.TaskTableHeader-module__secondary-border-t___ttGIM {
  border-top: 1px solid #637768;
}

.TaskTableHeader-module__secondary-border-l___kyy4D {
  border-left: 1px solid #637768;
}

.TaskTableHeader-module__secondary-border-r___Wvz0L {
  border-right: 1px solid #637768;
}

.TaskTableHeader-module__gap-0___xpsaz {
  gap: 0 !important;
}

.TaskTableHeader-module__gap-2___VEHZm {
  gap: 2px !important;
}

.TaskTableHeader-module__gap-4___Zw_q_ {
  gap: 4px !important;
}

.TaskTableHeader-module__gap-5___rzGk9 {
  gap: 5px !important;
}

.TaskTableHeader-module__gap-6___vawQ7 {
  gap: 6px !important;
}

.TaskTableHeader-module__gap-8___uuj4u {
  gap: 8px !important;
}

.TaskTableHeader-module__gap-10___UjAF_ {
  gap: 10px !important;
}

.TaskTableHeader-module__gap-12___xg6YI {
  gap: 12px !important;
}

.TaskTableHeader-module__gap-14___yDnMM {
  gap: 14px !important;
}

.TaskTableHeader-module__gap-16___kJn04 {
  gap: 16px !important;
}

.TaskTableHeader-module__gap-18___gTCz1 {
  gap: 18px !important;
}

.TaskTableHeader-module__gap-20___T9t4n {
  gap: 20px !important;
}

.TaskTableHeader-module__gap-24___WYndf {
  gap: 24px !important;
}

.TaskTableHeader-module__gap-26___uyg7C {
  gap: 26px !important;
}

.TaskTableHeader-module__gap-30___iahPm {
  gap: 30px !important;
}

.TaskTableHeader-module__gap-32___Pc3P6 {
  gap: 32px !important;
}

.TaskTableHeader-module__gap-40___jM4Pz {
  gap: 40px !important;
}

.TaskTableHeader-module__gap-50___NZUVR {
  gap: 50px !important;
}

.TaskTableHeader-module__flex-1___opd9o {
  flex: 1;
}

.TaskTableHeader-module__flex-none___yLKhO {
  flex: none !important;
}

.TaskTableHeader-module__flex-column___jpoB3 {
  display: flex;
  flex-direction: column !important;
}

.TaskTableHeader-module__flex-row___X99yl {
  display: flex;
  flex-direction: row !important;
}

.TaskTableHeader-module__vertically-centered___HUO0R {
  display: flex;
  align-items: center !important;
}

.TaskTableHeader-module__horizontally-centered___l_oJy {
  display: flex;
  justify-content: center !important;
}

.TaskTableHeader-module__horizontally-end___Wt_Xm {
  display: flex;
  justify-content: end !important;
}

.TaskTableHeader-module__vertically-start___QfcrC {
  display: flex;
  align-items: start !important;
}

.TaskTableHeader-module__space-between___gdxLv {
  display: flex;
  justify-content: space-between !important;
}

.TaskTableHeader-module__flex-wrap___dqw1d {
  flex-wrap: wrap !important;
}

.TaskTableHeader-module__height-100___HgGAr {
  height: 100%;
}

.TaskTableHeader-module__width-50___vznZ5 {
  width: 50% !important;
}

.TaskTableHeader-module__width-100___OzXgB {
  width: 100%;
}

.TaskTableHeader-module__cursor-pointer___U1AyD {
  cursor: pointer;
}

.TaskTableHeader-module__cursor-not-allowed___XLO4n {
  cursor: not-allowed !important;
}

.TaskTableHeader-module__absolute-centered___M3gVb {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TaskTableHeader-module__absolute___nwAen {
  position: absolute;
}

.TaskTableHeader-module__relative___pn5Cz {
  position: relative;
}

.TaskTableHeader-module__fixed____iyVJ {
  position: fixed;
}

.TaskTableHeader-module__visible___Wk1zT {
  opacity: 1;
}

.TaskTableHeader-module__invisible___p1WLD {
  opacity: 0;
}

.TaskTableHeader-module__col-90___yd1ZD {
  width: 90% !important;
}

.TaskTableHeader-module__col-auto___iOKrO {
  width: auto !important;
}

.TaskTableHeader-module__medical-tabs___X1Iqd {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TaskTableHeader-module__medical-table-new___Do8c8 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TaskTableHeader-module__medical-table-new___Do8c8:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TaskTableHeader-module__medical-table-new___Do8c8::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TaskTableHeader-module__medical-table-new___Do8c8::-webkit-scrollbar-track {
  display: none;
}
.TaskTableHeader-module__medical-table-new___Do8c8.TaskTableHeader-module__no-pagination___Xb6s0 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TaskTableHeader-module__medical-table-new___Do8c8.TaskTableHeader-module__no-pagination___Xb6s0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TaskTableHeader-module__medical-table-new___Do8c8.TaskTableHeader-module__no-pagination___Xb6s0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TaskTableHeader-module__medical-table-new___Do8c8.TaskTableHeader-module__no-pagination___Xb6s0::-webkit-scrollbar-track {
  display: none;
}

.TaskTableHeader-module__medical-table-empty___zUiz_ {
  padding: 14px 40px !important;
}

.TaskTableHeader-module__icon-btn___SAlRk {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TaskTableHeader-module__search-icon___NPISD {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TaskTableHeader-module__disable-select___W00dp {
  user-select: none;
}

.TaskTableHeader-module__break-word___a0R8i {
  word-break: break-word;
}

.TaskTableHeader-module__popup-clear-btn___qrI6Y {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TaskTableHeader-module__scroll-m-b-20___NkwwG {
  scroll-margin-bottom: 20px;
}

.TaskTableHeader-module__header___WAjI0 {
  display: flex;
  align-items: stretch;
  padding: 0 14px;
  border-bottom: 1px solid #f4f4f5;
  background: rgba(250, 250, 250, 0.6);
}

.TaskTableHeader-module__task___SUWfb {
  min-width: 0;
  flex: 1;
  padding: 5px 16px 5px 0;
}

.TaskTableHeader-module__cell___ylBXw {
  display: flex;
  min-width: 0;
  flex-shrink: 0;
  align-items: center;
  align-self: stretch;
  padding: 5px 16px;
  border-left: 1px solid #e4e4e7;
}

.TaskTableHeader-module__status___lxbm5 {
  width: 124px;
}

.TaskTableHeader-module__priority___qbO6j {
  width: 116px;
}

.TaskTableHeader-module__due___sx83V {
  width: 120px;
  justify-content: center;
  text-align: center;
}

.TaskTableHeader-module__sortButton___uQoV0 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
  outline: none;
}
.TaskTableHeader-module__sortButton___uQoV0:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.TaskTableHeader-module__sortActive___i2NXz {
  color: #18181b;
}

.TaskTableHeader-module__sortIcon___cS6pB {
  width: 9px;
  height: 9px;
  opacity: 0.6;
}

.TaskTableHeader-module__lead___z_HuI {
  display: flex;
  width: 24px;
  flex-shrink: 0;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/TaskTableHeader/TaskTableHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,gCAAA;EACA,oCAAA;AA8pBF;;AA3pBA;EACE,YAAA;EACA,OAAA;EACA,uBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;AA8pBF;;AA3pBA;EACE,YAAA;AA8pBF;;AA3pBA;EACE,YAAA;AA8pBF;;AA3pBA;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EEZA,aAAA;AF2qBF;AEzqBE;EACE,0BAAA;EACA,mBALuB;AFgrB3B;;AA/pBA;EACE,cAAA;AAkqBF;;AA/pBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AAkqBF;;AA/pBA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAkqBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  display: flex;\n  align-items: stretch;\n  padding: 0 14px;\n  border-bottom: 1px solid $rule;\n  background: rgba(250, 250, 250, 0.6);\n}\n\n.task {\n  min-width: 0;\n  flex: 1;\n  padding: 5px 16px 5px 0;\n}\n\n.cell {\n  display: flex;\n  min-width: 0;\n  flex-shrink: 0;\n  align-items: center;\n  align-self: stretch;\n  padding: 5px 16px;\n  border-left: 1px solid $hairline;\n}\n\n.status {\n  width: 124px;\n}\n\n.priority {\n  width: 116px;\n}\n\n.due {\n  width: 120px;\n  justify-content: center;\n  text-align: center;\n}\n\n.sortButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n  @include focus-ring;\n}\n\n.sortActive {\n  color: #18181b;\n}\n\n.sortIcon {\n  width: 9px;\n  height: 9px;\n  opacity: 0.6;\n}\n\n.lead {\n  display: flex;\n  width: 24px;\n  flex-shrink: 0;\n  align-items: center;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TaskTableHeader-module__font-s-10___6dH0S`,
	"fontS12": `TaskTableHeader-module__font-s-12___opbQ2`,
	"fontS13": `TaskTableHeader-module__font-s-13___BZ7pb`,
	"fontS14": `TaskTableHeader-module__font-s-14___sCAxo`,
	"fontS15": `TaskTableHeader-module__font-s-15___ALSKo`,
	"fontS16": `TaskTableHeader-module__font-s-16___CZ0Fj`,
	"fontS18": `TaskTableHeader-module__font-s-18___MWgdI`,
	"fontS20": `TaskTableHeader-module__font-s-20___C8ANH`,
	"fontS22": `TaskTableHeader-module__font-s-22___OwZdt`,
	"fontS28": `TaskTableHeader-module__font-s-28___GP6jL`,
	"fontW400": `TaskTableHeader-module__font-w-400___HDrCZ`,
	"fontW500": `TaskTableHeader-module__font-w-500___UpIBQ`,
	"fontW600": `TaskTableHeader-module__font-w-600___QyH92`,
	"fontW700": `TaskTableHeader-module__font-w-700___ThtRC`,
	"p5": `TaskTableHeader-module__p-5___tKmzs`,
	"p12": `TaskTableHeader-module__p-12___BeAwf`,
	"p16": `TaskTableHeader-module__p-16___Bia6M`,
	"p30": `TaskTableHeader-module__p-30___pGkKR`,
	"pB0": `TaskTableHeader-module__p-b-0___onF57`,
	"pB5": `TaskTableHeader-module__p-b-5___f0MaN`,
	"pB10": `TaskTableHeader-module__p-b-10___AQJNR`,
	"pB12": `TaskTableHeader-module__p-b-12___fM8aC`,
	"pB16": `TaskTableHeader-module__p-b-16___WB__Y`,
	"pB18": `TaskTableHeader-module__p-b-18___llZxp`,
	"pB20": `TaskTableHeader-module__p-b-20___bBYpV`,
	"pB25": `TaskTableHeader-module__p-b-25___GWblJ`,
	"pB30": `TaskTableHeader-module__p-b-30___wb97X`,
	"pB50": `TaskTableHeader-module__p-b-50___yMo5d`,
	"pT0": `TaskTableHeader-module__p-t-0___TY_PA`,
	"pT12": `TaskTableHeader-module__p-t-12___lfCNI`,
	"pT16": `TaskTableHeader-module__p-t-16___DzDPs`,
	"pT18": `TaskTableHeader-module__p-t-18___keO7Z`,
	"pT20": `TaskTableHeader-module__p-t-20___Ggn8a`,
	"pT30": `TaskTableHeader-module__p-t-30___sdk8r`,
	"pT40": `TaskTableHeader-module__p-t-40___SKu_b`,
	"pT50": `TaskTableHeader-module__p-t-50___cgpEV`,
	"pL20": `TaskTableHeader-module__p-l-20___vtKpW`,
	"pL30": `TaskTableHeader-module__p-l-30___LigoG`,
	"pL40": `TaskTableHeader-module__p-l-40___pACBU`,
	"pR16": `TaskTableHeader-module__p-r-16___BgnNR`,
	"pR20": `TaskTableHeader-module__p-r-20___eippp`,
	"pR30": `TaskTableHeader-module__p-r-30___qDAbj`,
	"pR50": `TaskTableHeader-module__p-r-50____yGUz`,
	"pR60": `TaskTableHeader-module__p-r-60___kiRNE`,
	"mB1": `TaskTableHeader-module__m-b-1___YqGvI`,
	"mB2": `TaskTableHeader-module__m-b-2___fcGhI`,
	"mB6": `TaskTableHeader-module__m-b-6___fqy5O`,
	"mB8": `TaskTableHeader-module__m-b-8___pQjJa`,
	"mB10": `TaskTableHeader-module__m-b-10___bD1lg`,
	"mB14": `TaskTableHeader-module__m-b-14___yYWCQ`,
	"mB16": `TaskTableHeader-module__m-b-16___YoySF`,
	"mB20": `TaskTableHeader-module__m-b-20___cJUhN`,
	"mB22": `TaskTableHeader-module__m-b-22___nUAYu`,
	"mB24": `TaskTableHeader-module__m-b-24___y3xlC`,
	"mB30": `TaskTableHeader-module__m-b-30___MKXEm`,
	"mB32": `TaskTableHeader-module__m-b-32___kdEj2`,
	"mB40": `TaskTableHeader-module__m-b-40___DdCBo`,
	"mT2": `TaskTableHeader-module__m-t-2___gME_Y`,
	"mT3": `TaskTableHeader-module__m-t-3___r451N`,
	"mT4": `TaskTableHeader-module__m-t-4___l3nv0`,
	"mT5": `TaskTableHeader-module__m-t-5___wMYXl`,
	"mT8": `TaskTableHeader-module__m-t-8___dyFiu`,
	"mT10": `TaskTableHeader-module__m-t-10___aak2C`,
	"mT15": `TaskTableHeader-module__m-t-15___WqE8b`,
	"mT16": `TaskTableHeader-module__m-t-16___Zm2kM`,
	"mT20": `TaskTableHeader-module__m-t-20___Z6Ouq`,
	"mT22": `TaskTableHeader-module__m-t-22___Gt1N8`,
	"mT30": `TaskTableHeader-module__m-t-30___mcF7W`,
	"mT32": `TaskTableHeader-module__m-t-32___XPXD1`,
	"mLAuto": `TaskTableHeader-module__m-l-auto___cUFH4`,
	"mL4": `TaskTableHeader-module__m-l-4___bBH30`,
	"mL5": `TaskTableHeader-module__m-l-5___coq0o`,
	"mL6": `TaskTableHeader-module__m-l-6___AvU20`,
	"mL8": `TaskTableHeader-module__m-l-8___GcXcO`,
	"mL10": `TaskTableHeader-module__m-l-10___KtyUD`,
	"mL16": `TaskTableHeader-module__m-l-16___m4TrT`,
	"mL20": `TaskTableHeader-module__m-l-20___Xfto_`,
	"mL24": `TaskTableHeader-module__m-l-24___mJi_P`,
	"mL30": `TaskTableHeader-module__m-l-30___g9Lo3`,
	"mL35": `TaskTableHeader-module__m-l-35___VPfAs`,
	"mL40": `TaskTableHeader-module__m-l-40___vqWSg`,
	"mR8": `TaskTableHeader-module__m-r-8___hJz0u`,
	"mR10": `TaskTableHeader-module__m-r-10___Jj_lw`,
	"mR16": `TaskTableHeader-module__m-r-16___IXSlK`,
	"mR20": `TaskTableHeader-module__m-r-20___JvbiS`,
	"mR24": `TaskTableHeader-module__m-r-24___cjZdI`,
	"mR30": `TaskTableHeader-module__m-r-30___hkvQy`,
	"mR40": `TaskTableHeader-module__m-r-40___FvzI1`,
	"borderR3": `TaskTableHeader-module__border-r-3___C9BOt`,
	"borderR4": `TaskTableHeader-module__border-r-4___ERuuw`,
	"borderR6": `TaskTableHeader-module__border-r-6___gX5Hb`,
	"borderR10": `TaskTableHeader-module__border-r-10___cbmG7`,
	"borderR12": `TaskTableHeader-module__border-r-12___ZBy_p`,
	"borderR16": `TaskTableHeader-module__border-r-16___tlnK6`,
	"borderR50": `TaskTableHeader-module__border-r-50___THjCw`,
	"primaryBorder": `TaskTableHeader-module__primary-border___a1htA`,
	"primaryBorderB": `TaskTableHeader-module__primary-border-b___NG3dP`,
	"primaryBorderT": `TaskTableHeader-module__primary-border-t___UrF9z`,
	"primaryBorderL": `TaskTableHeader-module__primary-border-l___RKWip`,
	"primaryBorderR": `TaskTableHeader-module__primary-border-r___onSW9`,
	"secondaryBorder": `TaskTableHeader-module__secondary-border___eQrH6`,
	"secondaryBorderB": `TaskTableHeader-module__secondary-border-b___US8dT`,
	"secondaryBorderT": `TaskTableHeader-module__secondary-border-t___ttGIM`,
	"secondaryBorderL": `TaskTableHeader-module__secondary-border-l___kyy4D`,
	"secondaryBorderR": `TaskTableHeader-module__secondary-border-r___Wvz0L`,
	"gap0": `TaskTableHeader-module__gap-0___xpsaz`,
	"gap2": `TaskTableHeader-module__gap-2___VEHZm`,
	"gap4": `TaskTableHeader-module__gap-4___Zw_q_`,
	"gap5": `TaskTableHeader-module__gap-5___rzGk9`,
	"gap6": `TaskTableHeader-module__gap-6___vawQ7`,
	"gap8": `TaskTableHeader-module__gap-8___uuj4u`,
	"gap10": `TaskTableHeader-module__gap-10___UjAF_`,
	"gap12": `TaskTableHeader-module__gap-12___xg6YI`,
	"gap14": `TaskTableHeader-module__gap-14___yDnMM`,
	"gap16": `TaskTableHeader-module__gap-16___kJn04`,
	"gap18": `TaskTableHeader-module__gap-18___gTCz1`,
	"gap20": `TaskTableHeader-module__gap-20___T9t4n`,
	"gap24": `TaskTableHeader-module__gap-24___WYndf`,
	"gap26": `TaskTableHeader-module__gap-26___uyg7C`,
	"gap30": `TaskTableHeader-module__gap-30___iahPm`,
	"gap32": `TaskTableHeader-module__gap-32___Pc3P6`,
	"gap40": `TaskTableHeader-module__gap-40___jM4Pz`,
	"gap50": `TaskTableHeader-module__gap-50___NZUVR`,
	"flex1": `TaskTableHeader-module__flex-1___opd9o`,
	"flexNone": `TaskTableHeader-module__flex-none___yLKhO`,
	"flexColumn": `TaskTableHeader-module__flex-column___jpoB3`,
	"flexRow": `TaskTableHeader-module__flex-row___X99yl`,
	"verticallyCentered": `TaskTableHeader-module__vertically-centered___HUO0R`,
	"horizontallyCentered": `TaskTableHeader-module__horizontally-centered___l_oJy`,
	"horizontallyEnd": `TaskTableHeader-module__horizontally-end___Wt_Xm`,
	"verticallyStart": `TaskTableHeader-module__vertically-start___QfcrC`,
	"spaceBetween": `TaskTableHeader-module__space-between___gdxLv`,
	"flexWrap": `TaskTableHeader-module__flex-wrap___dqw1d`,
	"height100": `TaskTableHeader-module__height-100___HgGAr`,
	"width50": `TaskTableHeader-module__width-50___vznZ5`,
	"width100": `TaskTableHeader-module__width-100___OzXgB`,
	"cursorPointer": `TaskTableHeader-module__cursor-pointer___U1AyD`,
	"cursorNotAllowed": `TaskTableHeader-module__cursor-not-allowed___XLO4n`,
	"absoluteCentered": `TaskTableHeader-module__absolute-centered___M3gVb`,
	"absolute": `TaskTableHeader-module__absolute___nwAen`,
	"relative": `TaskTableHeader-module__relative___pn5Cz`,
	"fixed": `TaskTableHeader-module__fixed____iyVJ`,
	"visible": `TaskTableHeader-module__visible___Wk1zT`,
	"invisible": `TaskTableHeader-module__invisible___p1WLD`,
	"col90": `TaskTableHeader-module__col-90___yd1ZD`,
	"colAuto": `TaskTableHeader-module__col-auto___iOKrO`,
	"medicalTabs": `TaskTableHeader-module__medical-tabs___X1Iqd`,
	"medicalTableNew": `TaskTableHeader-module__medical-table-new___Do8c8`,
	"noPagination": `TaskTableHeader-module__no-pagination___Xb6s0`,
	"medicalTableEmpty": `TaskTableHeader-module__medical-table-empty___zUiz_`,
	"iconBtn": `TaskTableHeader-module__icon-btn___SAlRk`,
	"searchIcon": `TaskTableHeader-module__search-icon___NPISD`,
	"disableSelect": `TaskTableHeader-module__disable-select___W00dp`,
	"breakWord": `TaskTableHeader-module__break-word___a0R8i`,
	"popupClearBtn": `TaskTableHeader-module__popup-clear-btn___qrI6Y`,
	"scrollMB20": `TaskTableHeader-module__scroll-m-b-20___NkwwG`,
	"header": `TaskTableHeader-module__header___WAjI0`,
	"task": `TaskTableHeader-module__task___SUWfb`,
	"cell": `TaskTableHeader-module__cell___ylBXw`,
	"status": `TaskTableHeader-module__status___lxbm5`,
	"priority": `TaskTableHeader-module__priority___qbO6j`,
	"due": `TaskTableHeader-module__due___sx83V`,
	"sortButton": `TaskTableHeader-module__sortButton___uQoV0`,
	"sortActive": `TaskTableHeader-module__sortActive___i2NXz`,
	"sortIcon": `TaskTableHeader-module__sortIcon___cS6pB`,
	"lead": `TaskTableHeader-module__lead___z_HuI`
};
module.exports = ___CSS_LOADER_EXPORT___;
